(function() {

  'use strict';

  eclipseApp.directive('passwordVerify', function() {
    return {
      restrict: 'A', // only activate on element attribute
      require: '?ngModel', // get a hold of NgModelController
      link: function(scope, elem, attrs, ngModel) {
        if(!ngModel) return; // do nothing if no ng-model

        // watch own value and re-validate on change
        scope.$watch(attrs.ngModel, function() {
          validate();
        });

        // observe the other value and re-validate on change
        attrs.$observe('passwordVerify', function (val) {
          validate();
        });

        var validate = function() {
          // values
          var val1 = ngModel.$viewValue;
          var val2 = attrs.passwordVerify;

          // set validity
          if(val1 && val2 && val1.length >= 4 && val1.length <= 5 && val2.length >= 4 && val2.length <= 5 && val1.length === val2.length){
          //if(val1 && val2 && val1.length === val2.length){
            //if(ngModel.$valid) {
              ngModel.$setValidity('passwordVerify', ! val1 || ! val2 || val1 === val2);
            //}
          }
        };
      }
    }
  });

})();
